var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeskStanding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10.25C9 9.83579 9.33579 9.5 9.75 9.5H14.25C14.6642 9.5 15 9.83579 15 10.25C15 10.6642 14.6642 11 14.25 11H9.75C9.33579 11 9 10.6642 9 10.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.75C6 1.33579 6.33579 1 6.75 1H17.25C17.6642 1 18 1.33579 18 1.75V7.75C18 8.16421 17.6642 8.5 17.25 8.5H6.75C6.33579 8.5 6 8.16421 6 7.75V1.75ZM7.5 2.5V7H16.5V2.5H7.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12.75C3 12.3358 3.33579 12 3.75 12H20.25C20.6642 12 21 12.3358 21 12.75C21 13.1642 20.6642 13.5 20.25 13.5H3.75C3.33579 13.5 3 13.1642 3 12.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 22.25V12.25H19V22.25C19 22.6642 18.6642 23 18.25 23C17.8358 23 17.5 22.6642 17.5 22.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 22.25V12.25H6.5V22.25C6.5 22.6642 6.16421 23 5.75 23C5.33579 23 5 22.6642 5 22.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskStanding);
export default __webpack_public_path__ + "static/media/DeskStanding.4c6b2fa17ca3191cf623430caf53587d.svg";
export { ForwardRef as ReactComponent };